import React, { Component } from 'react';
import { Grid, Col, Button } from 'react-bootstrap';
import NewsItem from '../common/NewsItem';
import blogposts from '../../blogposts';
import './News.css';

class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      visibleRows: [],
      visible: false,
    };

    this.createRows = this.createCols.bind(this);
    this.viewMoreHandler = this.viewMoreHandler.bind(this);
    this.state.newsItems = blogposts;

    this.state.newsItems = this.state.newsItems.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateA - dateB;
    });

    this.state.rows = this.createCols();

    for (let i = 0; i < 8; i += 1) {
      const item = this.state.rows.pop();
      this.state.visibleRows.push(item);
    }
    this.state.visible = this.state.rows.length > 0;
  }

  createCols() {
    const cols = this.state.newsItems.map((newsItem) => (
      <Col md={4} s={6} xs={12} className="column-style" key={newsItem.date}>
        <NewsItem
          classname="news-item"
          image={newsItem.image}
          title={newsItem.heading}
          content={newsItem.content}
          path={newsItem.path}
          next={newsItem.next}
          previous={newsItem.previous}
        />
      </Col>
    ));
    return cols;
  }

  viewMoreHandler() {
    const visibleRows = this.state.visibleRows.slice();
    const rows = this.state.rows.slice();

    for (let i = 0; i < 3; i += 1) {
      visibleRows.push(rows.pop());
    }
    const visible = rows.length !== 0;
    this.setState({
      visibleRows,
      rows,
      visible,
    });
    this.bottomRow.scrollIntoView({
      behavior: 'smooth',
    });
  }

  render() {
    const overlayDiv = (
      <div className="overlay-div">
        <Button className="view-more" onClick={this.viewMoreHandler}>
          VIEW MORE
        </Button>
      </div>
    );
    return (
      <div className="news">
        <Grid>
          <Col md={12}>
            <h3 className="blog-heading"> Latest</h3>
            <div className="news-items">
              {this.state.visibleRows}
              {this.state.visible && overlayDiv}
              <div
                className="ref-div"
                ref={(r) => {
                  this.bottomRow = r;
                }}
              />
            </div>
          </Col>
        </Grid>
      </div>
    );
  }
}

export default News;



// WEBPACK FOOTER //
// ./src/components/views/News.js